function cancanSidebarMobileNavInit() {
	const mobileNavBar = document.querySelector(
		'.wp-block-cancan-sidebar-nav .mobile-nav'
	);
	if (!mobileNavBar) return;

	const dropdownButton = mobileNavBar.querySelector('.dropdown-button');
	const dropdown = mobileNavBar.querySelector('#mobile-nav-dropdown');
	if (!dropdownButton || !dropdown) return;

	// Prevent double-binding
	if (dropdownButton.dataset.initialized) return;
	dropdownButton.dataset.initialized = 'true';

	const setDropdownState = (isOpen) => {
		dropdown.hidden = !isOpen;
		dropdownButton.classList.toggle('active', isOpen);

		// Set the top alignment for button resize
		const buttonHeight = dropdownButton.offsetHeight;
		dropdown.style.top = `${buttonHeight + 5}px`;

		dropdownButton.setAttribute('aria-expanded', String(isOpen));
		dropdown.setAttribute('aria-hidden', String(!isOpen));
	};

	const toggleDropdown = () => {
		setDropdownState(dropdown.hidden);
	};

	// Explicit initial state
	setDropdownState(false);

	dropdownButton.addEventListener('click', toggleDropdown);
}

document.addEventListener('DOMContentLoaded', cancanSidebarMobileNavInit);
